// Generated types for PowerFlow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLBehaviorReadAPI, SysMLBehaviorWriteAPI } from './sysmlbehavior';
import { SysMLBehaviorReadAPISchemaObject, SysMLBehaviorWriteAPISchemaObject } from './sysmlbehavior';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PowerFlowReadAPI extends SysMLBehaviorReadAPI {
  /** Voltage rating */
  voltage?: number | null;
  /** Current rating */
  current?: number | null;
  /** Power rating */
  power?: number | null;
}

export interface PowerFlowWriteAPI extends SysMLBehaviorWriteAPI {
  /** Voltage rating */
  voltage?: number | null;
  /** Current rating */
  current?: number | null;
  /** Power rating */
  power?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PowerFlowReadAPISchema: z.ZodType<PowerFlowReadAPI> = SysMLBehaviorReadAPISchemaObject.extend({
  voltage: z.number().nullable().optional(),
  current: z.number().nullable().optional(),
  power: z.number().nullable().optional(),
}).passthrough();

export const PowerFlowWriteAPISchema: z.ZodType<PowerFlowWriteAPI> = SysMLBehaviorWriteAPISchemaObject.extend({
  voltage: z.number().nullable().optional(),
  current: z.number().nullable().optional(),
  power: z.number().nullable().optional(),
}).passthrough();
